import NumberFormat from './NumberFormat';
Vue.filter('numberFormat', NumberFormat);

import fileSizeFormat from './fileSizeFormat';
Vue.filter('fileSizeFormat', fileSizeFormat);

Vue.filter('truncate', (value, length = 30) => {
    return _.truncate(value, { length, separator: /,? +/ });
});

import { mimeTypeIconClass } from './mime';
Vue.filter('mimeTypeIconClass', mimeTypeIconClass);
